/**
 * "You're offline" pill for the iOS app. The app's screens are bundled on
 * the phone, so it opens without signal — but search, checkout, payments and
 * chat need the network, and a spinner that never resolves reads as broken.
 * This says why, and clears itself the moment the connection is back.
 *
 * App only: in a browser tab the browser shows its own offline state.
 */
import React from 'react';
import { WifiOff } from 'lucide-react';
import { isNativeApp } from '@/native/bootstrap';
import { useOnline } from '@/native/offline';

export default function OfflineBanner() {
  const online = useOnline();
  if (!isNativeApp || online) return null;
  return (
    <div role="status" aria-live="polite" className="fixed inset-x-0 top-3 z-[9999] flex justify-center px-4 pointer-events-none">
      <div className="flex items-center gap-2.5 rounded-full border border-white/10 bg-black/85 px-4 py-2 text-white shadow-lg backdrop-blur">
        <WifiOff className="h-4 w-4 text-white/70" aria-hidden="true" />
        <span className="text-[13px] leading-5">
          You&apos;re offline <span className="text-white/55">· searching, booking and payments need a connection</span>
        </span>
      </div>
    </div>
  );
}
